import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { actionCreators } from '../actions/globalAction';
import { Wechselrichter } from '../components/solar/Wechselrichter'
import { wechselrichter } from '../components/objects/wechselrichter';


class WechselrichterClass extends Component {
    componentDidMount() {
        for (var k in wechselrichter) {
            this.props.request(wechselrichter[k]);
        }
    }

    renderSkeletonCard() {
        return (
            <div className="wechselrichter-card wechselrichter-skeleton">
                {/* Header skeleton */}
                <div className="wr-header">
                    <div className="wr-header-left">
                        <div className="skeleton-line" style={{ height: 24, width: 180 }} />
                        <div className="skeleton-line skeleton-sm" style={{ marginTop: 6 }} />
                    </div>
                </div>

                {/* Body skeleton */}
                <div className="wr-body">
                    {/* Image section */}
                    <div className="wr-image-section">
                        <div className="skeleton-line"
                             style={{ height: 80, width: 120, borderRadius: 6 }} />
                    </div>

                    {/* Section titles + rows */}
                    <div className="wr-section">
                        <div className="skeleton-line" style={{ height: 10, width: 80 }} />
                        <div className="skeleton-line" style={{ height: 20, width: '60%', marginTop: 10 }} />
                        <div className="skeleton-line" style={{ height: 20, width: '75%', marginTop: 12 }} />
                    </div>

                    {/* Cumulative boxes */}
                    <Row className="wr-cum-row">
                        {[0, 1, 2].map(j => (
                            <Col xs={4} key={j}>
                                <div className="wr-cum-box wr-cum-green" style={{ padding: '1rem 0.5rem' }}>
                                    <div className="skeleton-line" style={{ height: 22, width: '60%', margin: '0 auto' }} />
                                    <div className="skeleton-line skeleton-xs" style={{ marginTop: 8, width: '50%', margin: '8px auto 0' }} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        );
    }

    render() {
        const isLoaded = this.props.isLoaded;
        const ui = this.props.WechselrichterUI || [];
        const hasData = Array.isArray(ui) && ui.length > 0;
        const loading = !isLoaded || !hasData;

        return (
            <div>
                <h2 className="mb-4">Wechselrichter — Übersicht</h2>

                {loading ? (
                    <Row>
                        {[0, 1].map(i => (
                            <Col xs={12} lg={6} key={i}>
                                {this.renderSkeletonCard()}
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row>
                        {ui.map(wr => (
                            <Col xs={12} lg={6} key={wr.key}>
                                <Wechselrichter value={wr} />
                            </Col>
                        ))}
                    </Row>
                )}
            </div>
        );
    }
}

export default connect(
    state => state.wechselrichterReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(WechselrichterClass);
